<script lang="ts" setup>
const { t } = useI18n();
const { HOSTING_IS_PRODUCTION: isProduction } = useRuntimeConfig().public;

const { loggedIn, user } = useUserSession();

useHead({
  title: () => t("layouts.title"),
  titleTemplate: "%s",
});

// favicon
const favicon = computed(() => {
  const faviconBasePath = isProduction ? "favicon" : "favicon-preview";

  if (isBellaSicilia(loggedIn.value, user.value?.storeId)) {
    return {
      ico: `/bella-sicilia/${faviconBasePath}/favicon.ico`,
      svg: `/bella-sicilia/${faviconBasePath}/favicon.svg`,
      appleTouchIcon: `/bella-sicilia/${faviconBasePath}/apple-touch-icon.png`,
      webManifest: `/bella-sicilia/${faviconBasePath}/site.webmanifest`,
    };
  }

  return {
    ico: `/spuntini/${faviconBasePath}/favicon.ico`,
    svg: `/spuntini/${faviconBasePath}/favicon.svg`,
    appleTouchIcon: `/spuntini/${faviconBasePath}/apple-touch-icon.png`,
    webManifest: `/spuntini/${faviconBasePath}/site.webmanifest`,
  };
});

// i18n
const head = useLocaleHead({
  dir: true,
  lang: true,
  seo: true,
});

// pre-register swiper
useSwiper();
</script>

<template>
  <Html :lang="head?.htmlAttrs?.lang" :dir="head?.htmlAttrs?.dir">
    <Head>
      <template v-for="meta in head.meta" :key="meta.id">
        <Meta :id="meta.id" :property="meta.property" :content="meta.content" />
      </template>

      <!-- https://favicon.inbrowser.app/tools/favicon-generator -->
      <Link rel="apple-touch-icon" :href="favicon.appleTouchIcon" />
      <Link rel="icon" :href="favicon.ico" sizes="48x48" />
      <Link rel="icon" :href="favicon.svg" sizes="any" type="image/svg+xml" />
      <Link rel="manifest" :href="favicon.webManifest" />
      <Meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <Meta name="theme-color" content="#C81414" media="(prefers-color-scheme: light)" />
      <Meta name="theme-color" content="#C81414" media="(prefers-color-scheme: dark)" />
      <Meta name="google-site-verification" content="Ku8sCA5QouiTklVyhWN0ITVZZA0v-kzSFJk4oEW0-mw" />
    </Head>
    <Body class="bg-[#F8F7F4]">
      <DatoContentLinkWrapper />
      <HeaderBase />
      <main>
        <div class="container mx-auto">
          <slot />
        </div>
      </main>
      <FooterBase />
    </Body>
  </Html>
</template>

<style></style>
